import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';
import moment from 'moment';
import Helper from './helper';
import Datepicker from 'views/plugins/ui/form/datepicker';

class AvailabilityDatepicker extends React.Component {
  static displayName = 'AvailabilityDatepicker';

  static propTypes = {
    fromDate: PropTypes.object.isRequired,
    toDate: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    className: PropTypes.string,
    label: PropTypes.string,
  };

  static defaultProps = {
    onChange: function () {},
    className: '',
    label: null,
  };

  state = {
    fromDate: {
      value: this.props.fromDate.value,
      formattedValue: moment(
        this.props.fromDate.value,
        this.props.defaultDateFormat
      ).format(this.props.defaultDateFormat),
      disabled: this.props.fromDate.disabled,
    },
    toDate: {
      value: this.props.toDate.value,
      formattedValue: moment(
        this.props.toDate.value,
        this.props.defaultDateFormat
      ).format(this.props.defaultDateFormat),
      disabled: this.props.toDate.disabled,
    },
  };

  _fromDateChanged = (name, value, formattedValue) => {
    var fromDateState, toDateState, toDate;

    fromDateState = {
      value: value,
      formattedValue: formattedValue,
      disabled: false,
    };
    toDateState = _.clone(this.state.toDate);

    if (this.state.toDate.value === null || value > this.state.toDate.value) {
      toDateState = fromDateState;
    }
    this._dateChanged({ fromDate: fromDateState, toDate: toDateState });
  };

  _toDateChanged = (name, value, formattedValue) => {
    this._dateChanged({
      toDate: {
        value: value,
        formattedValue: formattedValue,
        disabled: false,
      },
    });
  };

  _dateChanged = (newState) => {
    this.setState(newState);
    this.props.onChange.call(
      this,
      this.state.fromDate.formattedValue,
      this.state.toDate.formattedValue,
      this.props.defaultDateFormat
    );
  };

  _className = () => {
    return 'AvailabilityDatepicker ' + this.props.className;
  };

  _renderLabel = () => {
    return <label>{this.props.label}</label>;
  };

  render() {
    return (
      <div className={this._className()}>
        {this.props.label ? this._renderLabel() : null}
        <div className={this.props.fromDate.className}>
          <Datepicker
            {...this.props.fromDate}
            onChange={this._fromDateChanged}
            disabled={this.state.fromDate.disabled}
          />
        </div>
        <div className={this.props.toDate.className}>
          <Datepicker
            {...this.props.toDate}
            onChange={this._toDateChanged}
            disabled={this.state.toDate.disabled}
          />
        </div>
      </div>
    );
  }
}

export default {
  component: AvailabilityDatepicker,
  props: Helper.props,
};
